
































import {Component, Vue, Watch} from "vue-property-decorator";
import {namespace} from "vuex-class";


import OrderButtonLocationSize from "@/views/components/Orders/OrderButtonLocationSize.vue";
import TextAreaInput from "@/views/components/FormInputs/TextAreaInput.vue";
import {AMAZON_RETURNS_ROUTES} from "@/constants/routes";
import {stripHtmlTags} from "@/helpers/stringHelpers";

const shipmentStore = namespace("shipment");
const hubsStore = namespace("hubs");

@Component({
  name: 'AmazonReturnsForm',
  components: {
    TextAreaInput,
    OrderButtonLocationSize,
  },
})
export default class AmazonReturnsForm extends Vue {

  @shipmentStore.Getter("getNote")
  private getNote!: string;

  @shipmentStore.Action("setNotes")
  private setNotes!: (notes: string) => void;

  private notes: string = "";
  private isAddressSizeValid: boolean = false;

  private created() {
    this.notes = this.getNote;
  }

  private sanitizeInputs() {
    this.notes = stripHtmlTags(this.notes);
  }

  private next() {
    if (this.isAddressSizeValid) {
      this.sanitizeInputs();
      this.setNotes(this.notes);
      this.$router.push({name: AMAZON_RETURNS_ROUTES.SUMMARY});
    }
  }

  private setIsAddressSizeValid(isAddressSizeValid: boolean) {
    this.isAddressSizeValid = isAddressSizeValid;
  }
}
